import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useElementById } from '../useElementById/useElementById.js';

const useConfirmationModal = ({ elementId, }) => {
    const modalRootElementRef = useElementById(elementId);
    const [node, setNode] = useState(null);
    const open = useCallback((builder) => __awaiter(void 0, void 0, void 0, function* () {
        const promise = new Promise((resolve, reject) => {
            try {
                setNode(builder(resolve, reject));
            }
            catch (err) {
                reject(err);
            }
        });
        return promise.finally(() => {
            setNode(undefined);
        });
    }), [setNode]);
    return {
        modal: node ? (jsx("div", { children: createPortal(node, modalRootElementRef.current) })) : undefined,
        open,
    };
};

export { useConfirmationModal };
